import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SalesDnaComponent } from './sales-dna.component';
import { ConfigurePipelineComponent } from './components/configure-pipeline/configure-pipeline.component';
import { ConfigureNodeComponent } from './components/configure-node/configure-node.component';
import { SelectedProjectComponent } from './components/selected-project/selected-project.component';
import { SolutionsVersionsComponent } from './components/solutions-versions/solutions-versions.component';
import { CreateSolutionsComponent } from './components/create-solutions/create-solutions.component';
import { MySolutionHomepageComponent } from './components/my-solution-homepage/my-solution-homepage.component';
import { AddProjectsComponent } from './components/add-projects/add-projects.component';
import { SolutionConfigurationFormComponent } from './components/solution-configuration-form/solution-configuration-form.component';
import { canDeactivateFn } from 'src/app/guards/upload-data.guard';

const routes: Routes = [
  {
    path: '',
    component: SalesDnaComponent,
    children: [
      {
        path: 'mySolutions',
        component: MySolutionHomepageComponent,
      },
      {
        path: 'mySolutions/:solutionId',
        component: SolutionsVersionsComponent,
        canDeactivate: [canDeactivateFn],
      },
      { path: 'form', component: SolutionConfigurationFormComponent },
      { path: 'create-solution', component: CreateSolutionsComponent },
      { path: 'mySolutions/:solutionId/:versionId/configureProject', component: AddProjectsComponent },
      {
        path: 'mySolutions/:solutionId/:versionId/:projectId',
        component: SelectedProjectComponent,
        children: [
          { path: 'configurePipeline', component: ConfigurePipelineComponent },
          {
            path: 'configurePipeline/:pipelineId/configureNodes',
            component: ConfigureNodeComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SalesDnaRoutingModule {}
